import { useQuery } from '@tanstack/react-query'
import { apiFetchFull } from './client'

export interface LocationOverviewRow {
  area: string
  total_items: number
  distinct_items: number
  total_quantity: number
  fill_pct: number
}

export function useLocationOverview() {
  return useQuery({
    queryKey: ['inventory', 'locations'],
    queryFn: async () => {
      const res = await apiFetchFull<LocationOverviewRow[]>('/inventory/locations/')
      return res.data ?? []
    },
    staleTime: 60_000,
  })
}
